<template>
   <div >
      <div class="mfooter"   v-if="isMobile">
          <p class="ts">客服QQ：3001238329</p>
          <p class="ts">客服热线：<a href="tel:0731-85413362">0731-85413362</a></p>
          <p class="ts">服务时间：<b>09:00-17:00</b></p>
           <p>
              湘ICP备19010355号-2 | 湘公网安备 43010302001070号
          </p>
          <p>
              友情链接：<a target="_blank" href="http://www.chinagungho.org/">中国工业合作协会</a> | <a href="http://www.dailiantong.com/" target="_blank">代练通</a>
          </p>
      </div>
       <div class="footer" v-else>
          <div class="content">
          <ul>
              <!-- <li ><router-link  to="/qa" ><i></i>常见问题<em class="triangle-right triangle-right-blue"></em></router-link></li> -->
              <li>客服QQ：3001238329 </li>
              <li><i  class="icon3 icon3-tel mt5"></i> 客服热线：<a href="tel:0731-85413362">0731-85413362</a></li>
              <li><i  class="icon3 icon3-tel mt5"></i> 服务时间：<b>09:00-17:00</b></li>
          </ul>
          <div class="clear"></div>
          <p>
              <a target="_blank" href="http://beian.miit.gov.cn/">湘ICP备2021011745号-1</a> | 湘公网安备 43010302001070号
          </p>
          <p>
              友情链接：<a target="_blank" href="http://www.chinagungho.org/">中国工业合作协会</a> | <a href="http://www.dailiantong.com/" target="_blank">代练通</a>
          </p>
          </div>
      </div>
   </div>
</template>

<script>
export default {
  name: 'footer1',
  data () {
    return {
    }
  },
  computed:{
    isMobile(){
       return this.common.isMobile();
     }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/footer.vue